export class VoiceOrderHandoffStorageSerializer {
    serializeForStorage(data) {
        return JSON.stringify(data);
    }
    deserializeFromStorage(data) {
        try {
            const handoff = JSON.parse(data);
            this.assertValid(handoff);
            return handoff;
        }
        catch (error) {
            return null;
        }
    }
    assertValid(data) {
        if (typeof data !== "object" ||
            data === null ||
            typeof data.restaurantId !== "number" ||
            typeof data.token !== "string" ||
            typeof data.expiresAt !== "string" ||
            Number.isNaN(Date.parse(data.expiresAt))) {
            throw new Error("Invalid voice order handoff data");
        }
    }
}
